import React, { useMemo } from 'react';
import SelectMenu from '../../shared/SelectMenu';

const fmtWindowLabel = (window) => {
  if (!window) return '';
  const fmt = (date) => new Date(date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  return `${fmt(window.date_start)} – ${fmt(window.date_end)}`;
};

// A window is identified by its start|end pair — used as the SelectMenu option value
// (matched with ===) so the object round-trips back to the caller's onChange(window).
const windowKey = (window) => `${window.date_start}|${window.date_end}`;

// Window picker for the GA4 analysis-window tabs (Referrals, Pages, Geo, Tech and
// Traffic Overview). The hand-rolled dropdown this replaced had no click-outside /
// Escape close and was clipped by overflow-hidden parents; delegating to the shared
// SelectMenu (portal popover) fixes all three while keeping the external contract
// identical — onChange still receives the full window object, not a key.
const WindowSelector = ({ windows, selected, onChange, rangeStart, rangeEnd }) => {
  const filteredWindows = useMemo(() => {
    if (!windows || windows.length === 0) return [];
    if (!rangeStart || !rangeEnd) return windows;
    const overlapping = windows.filter(window => window.date_start <= rangeEnd && window.date_end >= rangeStart);
    return overlapping.length > 0 ? overlapping : windows;
  }, [windows, rangeStart, rangeEnd]);

  const options = useMemo(
    () => filteredWindows.map((window) => ({ value: windowKey(window), label: fmtWindowLabel(window) })),
    [filteredWindows],
  );

  if (filteredWindows.length === 0) return null;

  return (
    <SelectMenu
      options={options}
      value={selected ? windowKey(selected) : undefined}
      onChange={(key) => {
        const window = filteredWindows.find((candidate) => windowKey(candidate) === key);
        if (window) onChange(window);
      }}
      placeholder="Select window"
      ariaLabel="Select window"
      className="text-xs max-[589px]:w-full max-[589px]:min-w-0"
    />
  );
};

export { WindowSelector, fmtWindowLabel };
